// Inspired by https://github.com/gkaemmer/react-fade-in

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

export function FadeIn({ children, className, delay, transitionDuration }) {
  const [maxVisible, setMaxVisible] = useState(0);
  const interval = useRef();

  const childEls = _.compact(React.Children.toArray(children));

  useEffect(() => {
    const count = _.size(childEls);
    let i = 0;
    interval.current = setInterval(() => {
      i += 1;
      if (i > count) {
        clearInterval(interval.current);
      }

      setMaxVisible(i);
    }, delay);

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, [_.size(childEls)]);

  return (
    <div className={className} role='list'>
      {_.map(childEls, (child, i) => (
        <div
          key={i}
          style={{
            transition: `opacity ${transitionDuration}ms, transform ${transitionDuration}ms`,
            opacity: maxVisible > i ? 1 : 0,
          }}
        >
          {child}
        </div>
      ))}
    </div>
  );
}

FadeIn.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  delay: PropTypes.number,
  transitionDuration: PropTypes.number,
};

FadeIn.defaultProps = {
  delay: 50,
  transitionDuration: 400,
};
